<template>
  <svg
    viewBox="0 0 120 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="['logo-svg', { 'is-inherit': variant === 'inherit' }]"
    aria-label="Tracktor"
  >
    <path d="M 20 52 Q 15 60 15 70 L 25 70 Q 25 58 28 52 Z" fill="currentColor"></path>
    <rect x="28" y="28" width="38" height="25" fill="currentColor"></rect>
    <path d="M 26 29 L 26 18 L 68 18 L 68 29 Z" fill="currentColor"></path>
    <rect x="32" y="22" width="14" height="8" fill="#0E1621" opacity="0.5"></rect>
    <rect x="50" y="22" width="14" height="8" fill="#0E1621" opacity="0.5"></rect>
    <rect x="64" y="8" width="3" height="10" rx="1" fill="currentColor"></rect>
    <ellipse cx="65.5" cy="8" rx="4" ry="2" fill="currentColor"></ellipse>
    <path
      d="M 66 42 L 85 42 Q 95 42 100 48 L 105 55 Q 108 58 108 62 L 108 68 L 77 68 Q 72 68 68 64 Q 66 62 66 58 Q 66 56 66 53 Z"
      fill="currentColor"
    ></path>
    <line x1="86" y1="48" x2="90" y2="52" stroke="#0E1621" stroke-width="1" opacity="0.3"></line>
    <line x1="90" y1="48" x2="94" y2="52" stroke="#0E1621" stroke-width="1" opacity="0.3"></line>
    <line x1="94" y1="48" x2="98" y2="52" stroke="#0E1621" stroke-width="1" opacity="0.3"></line>
    <path
      d="M 66 42 Q 67 36 68 32"
      stroke="currentColor"
      stroke-width="4"
      fill="none"
      stroke-linecap="round"
    ></path>
    <path
      d="M 66 53 Q 67 48 68 45"
      stroke="currentColor"
      stroke-width="4"
      fill="none"
      stroke-linecap="round"
    ></path>
    <g class="wheel-spin-big">
      <circle cx="35" cy="70" r="22" fill="currentColor"></circle>
      <rect
        x="55.5"
        y="67"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(0 57 70)"
      ></rect>
      <rect
        x="52.55255888325765"
        y="78"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(30 54.05255888325765 81)"
      ></rect>
      <rect
        x="44.5"
        y="86.05255888325765"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(60 46 89.05255888325765)"
      ></rect>
      <rect
        x="33.5"
        y="89"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(90 35 92)"
      ></rect>
      <rect
        x="22.500000000000007"
        y="86.05255888325766"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(120 24.000000000000007 89.05255888325766)"
      ></rect>
      <rect
        x="14.447441116742347"
        y="78"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(150 15.947441116742347 81)"
      ></rect>
      <rect
        x="11.5"
        y="67"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(180 13 70)"
      ></rect>
      <rect
        x="14.44744111674235"
        y="56"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(210 15.94744111674235 59)"
      ></rect>
      <rect
        x="22.49999999999999"
        y="47.947441116742354"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(240 23.99999999999999 50.947441116742354)"
      ></rect>
      <rect
        x="33.49999999999999"
        y="45"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(270 34.99999999999999 48)"
      ></rect>
      <rect
        x="44.5"
        y="47.947441116742354"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(300 46 50.947441116742354)"
      ></rect>
      <rect
        x="52.552558883257646"
        y="55.999999999999986"
        width="3"
        height="6"
        fill="currentColor"
        transform="rotate(330 54.052558883257646 58.999999999999986)"
      ></rect>
      <circle cx="35" cy="70" r="14" fill="#229ed9"></circle>
      <circle cx="35" cy="70" r="6" fill="currentColor"></circle>
      <circle cx="35" cy="64" r="1.5" fill="#229ed9"></circle>
      <circle cx="35" cy="76" r="1.5" fill="#229ed9"></circle>
      <circle cx="29" cy="70" r="1.5" fill="#229ed9"></circle>
      <circle cx="41" cy="70" r="1.5" fill="#229ed9"></circle>
    </g>
    <g class="wheel-spin-small">
      <circle cx="90" cy="79" r="13" fill="currentColor"></circle>
      <rect
        x="102"
        y="77"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(0 103 79)"
      ></rect>
      <rect
        x="98.95857776054672"
        y="85.35623892592501"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(40 99.95857776054672 87.35623892592501)"
      ></rect>
      <rect
        x="91.2574263096701"
        y="89.8025007891587"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(80 92.2574263096701 91.8025007891587)"
      ></rect>
      <rect
        x="82.5"
        y="88.2583302491977"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(120 83.5 90.2583302491977)"
      ></rect>
      <rect
        x="76.78399592978319"
        y="81.4462618632337"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(160 77.78399592978319 83.4462618632337)"
      ></rect>
      <rect
        x="76.78399592978319"
        y="72.55373813676631"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(200 77.78399592978319 74.55373813676631)"
      ></rect>
      <rect
        x="82.5"
        y="65.7416697508023"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(240 83.5 67.7416697508023)"
      ></rect>
      <rect
        x="91.2574263096701"
        y="64.1974992108413"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(280 92.2574263096701 66.1974992108413)"
      ></rect>
      <rect
        x="98.95857776054672"
        y="68.64376107407499"
        width="2"
        height="4"
        fill="currentColor"
        transform="rotate(320 99.95857776054672 70.64376107407499)"
      ></rect>
      <circle cx="90" cy="79" r="8" fill="#229ed9"></circle>
      <circle cx="90" cy="79" r="4" fill="currentColor"></circle>
      <circle cx="90" cy="75" r="1" fill="#229ed9"></circle>
      <circle cx="90" cy="83" r="1" fill="#229ed9"></circle>
      <circle cx="86" cy="79" r="1" fill="#229ed9"></circle>
      <circle cx="94" cy="79" r="1" fill="#229ed9"></circle>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LogoIcon',
  props: {
    variant: {
      type: String,
      default: 'brand',
      validator: value => ['brand', 'inherit'].includes(value),
    },
  },
}
</script>

<style scoped>
.logo-svg {
  width: 1.75rem;
  height: 1.75rem;
  color: white;
}

.logo-svg.is-inherit {
  color: currentColor;
}

@keyframes wheel-rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.wheel-spin-big {
  animation: wheel-rotation 3s linear infinite;
  transform-origin: 35px 70px;
}

.wheel-spin-small {
  animation: wheel-rotation 3s linear infinite;
  transform-origin: 90px 79px;
}

@media (max-width: 640px) {
  .logo-svg {
    width: 1.5rem;
    height: 1.5rem;
  }
}
</style>
